import { interfaces } from 'inversify';

export default function (inversifyContainer: interfaces.Container) {
    return {
        install(vue: any, options: any) {
            vue.mixin({
                methods: {
                    resolveService(className: string, name: string|null = null) {
                        if (name == null)
                            return inversifyContainer.get(className);

                        return inversifyContainer.getNamed(className, name);
                    }
                }
            });

            vue.directive('focus', {
                inserted: function (el: HTMLElement) {
                    el.focus();
                }
            });

            vue.directive('adjust-scroll-on-focus', {
                inserted: function (el: HTMLElement) {
                    el.addEventListener('focusin', (e: FocusEvent) => {
                        let fixedBottomPos = el.getBoundingClientRect().bottom;
                        let rect = (<HTMLElement> e.target)?.getBoundingClientRect();
                        if (rect.top < fixedBottomPos) {
                            window.scrollBy(0, rect.top - fixedBottomPos);
                        }
                    });
                }
            });
        }
    }

}